import React from 'react';
import Buttons from '../Common/Buttons';
import Ticks from '../Common/Ticks';
import { useLocale } from '../../localization/LocaleContext';
import '../NicheLanding/NicheLandingPage.css';

function InvoiceMockup({ t }) {
    return (
        <div className="niche-invoice-mockup">
            <div className="niche-invoice-header">
                <div className="niche-invoice-logo-placeholder">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                        <polyline points="9 22 9 12 15 12 15 22"/>
                    </svg>
                </div>
                <div>
                    <div className="niche-invoice-title-text">INVOICE</div>
                    <div className="niche-invoice-number">#INV-2026-0134</div>
                </div>
            </div>
            <div className="niche-invoice-divider" />
            <div className="niche-invoice-parties">
                <div>
                    <div className="niche-invoice-label">{t('smallBusiness.invoiceFrom')}</div>
                    <div className="niche-invoice-name">{t('smallBusiness.invoiceSender')}</div>
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div className="niche-invoice-label">{t('smallBusiness.invoiceTo')}</div>
                    <div className="niche-invoice-name">{t('smallBusiness.invoiceRecipient')}</div>
                </div>
            </div>
            <div className="niche-invoice-table">
                <div className="niche-invoice-table-header">
                    <span>{t('smallBusiness.invoiceItemHeader')}</span>
                    <span>{t('smallBusiness.invoiceAmountHeader')}</span>
                </div>
                <div className="niche-invoice-table-row">
                    <span>{t('smallBusiness.invoiceItem1')}</span>
                    <span>{t('smallBusiness.invoiceItem1Price')}</span>
                </div>
                <div className="niche-invoice-table-row">
                    <span>{t('smallBusiness.invoiceItem2')}</span>
                    <span>{t('smallBusiness.invoiceItem2Price')}</span>
                </div>
            </div>
            <div className="niche-invoice-total-row">
                <span className="niche-invoice-total-label">Total</span>
                <span className="niche-invoice-total-value">{t('smallBusiness.invoiceTotal')}</span>
            </div>
            <div className="niche-invoice-status">{t('smallBusiness.invoiceStatus')}</div>
        </div>
    );
}

function Banner(){
    const { t } = useLocale();

    return(
        <section className="niche-hero sp-60">
            <div className="container">
                <div className="row flex-column-reverse flex-lg-row align-items-center">
                    <div className="col-lg-6">
                        <h1 className="h-1 h-bold niche-hero-title">
                            {t('smallBusiness.bannerTitleStart')}{' '}
                            <span className="niche-hero-highlight">{t('smallBusiness.bannerTitleHighlight')}</span>{' '}
                            {t('smallBusiness.bannerTitleMiddle')}{' '}
                            <span className="niche-hero-highlight">{t('smallBusiness.bannerTitleEnd')}</span>
                        </h1>
                        <p className="niche-hero-description">
                            {t('smallBusiness.bannerSubtitle')}
                        </p>
                        <Buttons />
                        <div className="mt-20">
                            <Ticks />
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <InvoiceMockup t={t} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Banner;